/**
 * Soka Newsletter Section
 * Minimal vanilla JS: scroll-triggered fade-up reveal + accessible success focus.
 * No dependencies. No jQuery.
 */
(function () {
  'use strict';

  var sections = document.querySelectorAll('[data-section-type="soka-newsletter"]');
  if (!sections.length) return;

  sections.forEach(function (section) {
    var animatedEls = section.querySelectorAll('.soka-newsletter--animate');

    if (!('IntersectionObserver' in window) || !animatedEls.length) {
      animatedEls.forEach(function (el) {
        el.classList.add('soka-newsletter--in-view');
      });
    } else {
      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry, index) {
            if (entry.isIntersecting) {
              var target = entry.target;
              window.setTimeout(function () {
                target.classList.add('soka-newsletter--in-view');
              }, index * 100);
              obs.unobserve(target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
      );

      animatedEls.forEach(function (el) {
        observer.observe(el);
      });
    }

    var successMessage = section.querySelector('[data-success-message]');
    if (successMessage) {
      successMessage.focus();
    }
  });
})();
